/**
 * Header menu helpers.
 * - Tapping the dimmed area beside the mobile menu closes it (the dim layer is a pseudo-element of the <details>).
 * - On laptops and desktops (a real mouse), the dropdown menus open when the pointer rests on them and close shortly
 *   after it leaves. Touch screens and keyboards keep the click / Enter behaviour.
 */
(() => {
  document.addEventListener('click', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLElement) || !details.matches('.menu-drawer-container.menu-opening')) return;

    // A click on the pseudo-element reports the <details> itself as its target.
    const drawer = details.closest('header-drawer');
    const summary = details.querySelector(':scope > summary');
    if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, summary);
    }
  });
})();

(() => {
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const CLOSE_DELAY = 220;
  const OPEN_DELAY = 60;

  const setup = (menu) => {
    const details = menu.querySelector(':scope > details');
    const summary = details && details.querySelector(':scope > summary');
    if (!details || !summary || menu.dataset.gsdHover) return;
    menu.dataset.gsdHover = 'true';

    let openTimer;
    let closeTimer;

    const open = () => {
      clearTimeout(closeTimer);
      if (details.open) return;
      clearTimeout(openTimer);
      openTimer = setTimeout(() => {
        // One menu at a time
        document.querySelectorAll('header-menu > details[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
        details.setAttribute('open', '');
      }, OPEN_DELAY);
    };

    const close = () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        // Keep it open only while a link inside has keyboard focus (a mouse click leaves focus behind too)
        if (!details.querySelector(':focus-visible')) details.removeAttribute('open');
      }, CLOSE_DELAY);
    };

    menu.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !hoverQuery.matches) return;
      open();
    });
    menu.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse' || !hoverQuery.matches) return;
      close();
    });

    // A mouse click on the title keeps the menu open (it was already opened by hovering); keyboard presses still toggle.
    summary.addEventListener(
      'click',
      (event) => {
        if (!hoverQuery.matches || event.detail === 0) return;
        event.preventDefault();
        event.stopPropagation();
        details.setAttribute('open', '');
      },
      true
    );
  };

  const init = () => document.querySelectorAll('header-menu').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
